import Layout from "../../layout/Layout";
import {Logo} from "../../components/Logo/Logo";
import {Footer} from "../../components/Footer/Footer";
import {VideoPlaylist} from "../../components/VideoPlaylist/VideoPlaylist"

const LandingPageNew = () => {
    return (
        <Layout>
            <Logo />
            <VideoPlaylist />
            <Footer />
        </Layout>
    );
};

export default LandingPageNew;